<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="名称">
            <el-select v-model="form.invoiceChannelId" clearable>
              <el-option
                v-for="(item, index) in selectListData"
                :label="item.invoiceChannel"
                :value="item.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm
              title="您确定要删除多条数据吗？"
              @confirm="deleteData"
            >
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <!-- <el-button class="btnBorderColor">导入</el-button> -->
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')"
              >新增发票说明</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addChannel('dialogForm')"
              >渠道维护</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="margin-top: 20px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            prop="invoiceChannel"
            label="发票查询渠道"
            min-width="140"
            align="center"
          />
          <el-table-column
            prop="imgUrl"
            label="步骤说明"
            min-width="160"
            show-overflow-tooltip
            align="center"
          >
            <template #default="scope">
              <span class="aHref" @click="step(scope)">步骤说明</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="updatedTime"
            label="变更时间"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="updatedBy"
            label="变更人"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="remark"
            label="备注"
            show-overflow-tooltip
            min-width="260"
            align="center"
          />
          <el-table-column label="操作" align="center" min-width="100">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm
                  title="您确认要删除该条数据吗？"
                  @confirm="deleteOnly(scope.row)"
                >
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.page"
            :page-sizes="[20, 40, 60, 80, 100]"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="`${title}发票说明`"
      :visible.sync="dialogVisible"
      width="810px"
      @close="cancelBtn('dialogForm')"
    >
      <div class="forms">
        <el-form
          :model="dialogForm"
          :rules="dialogRules"
          ref="dialogForm"
          label-width="80px"
          class="demo-dialogForm"
          label-position="left"
        >
          <el-form-item label="查询渠道" prop="invoiceChannelId">
            <div style="display: flex">
              <el-select v-model="dialogForm.invoiceChannelId" clearable>
                <el-option
                  v-for="(item, index) in selectListData"
                  :label="item.invoiceChannel"
                  :value="item.id"
                  :key="index"
                ></el-option>
              </el-select>
              <div
                style="display: flex; align-items: center; margin-left: 5px"
                @click="addFaultCause"
              >
                <img
                  style="width: 22px; height: 22px; margin-right: 5px"
                  src="@/assets/gzh/pc/add.png"
                  alt=""
                />
                <span>新增图片说明</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-for="(item, index) in descriptionList" :key="index">
            <div style="display: flex">
              <div class="content">
                <el-form :model="explainForm" ref="imageForm">
                  <div
                    style="display: flex; justify-content: space-around"
                    @click="beforeUpload(index)"
                  >
                    <el-form-item label="添加图片" style="margin-right: 40px">
                      <el-upload
                        class="avatar-uploader"
                        :action="`${upload}/file/uploadNew`"
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        list-type="picture-card"
                      >
                        <img
                          v-if="descriptionList[index].imgUrl"
                          :src="descriptionList[index].imgUrl"
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="步骤说明">
                      <el-input
                        type="textarea"
                        v-model="descriptionList[index].description"
                        placeholder="请输入步骤"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <div @click="deleteFaultCause(index)">
                <img
                  style="
                    width: 22px;
                    height: 22px;
                    margin-top: 3px;
                    margin-left: 5px;
                  "
                  src="@/assets/gzh/pc/reduce.png"
                  alt=""
                />
              </div>
            </div>
          </el-form-item>
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')"
              >取 消</el-button
            >
            <el-button
              class="dialogBtnBackgory"
              @click="submitForm('dialogForm')"
              >确 定</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${invoiceChannel}天猫发票查询引导`"
      :visible.sync="showStepGuidance"
      style="width: 100%"
    >
      <div
        class="guidance"
        v-for="(item, index) in stepExplain"
        :key="item.id"
        style="width: 100%"
      >
        <div class="guidanceTitle">
          {{ index + 1 + "、" + item.description }}
        </div>
        <div class="guidanceContent">
          <img
            class="guidanceImg"
            :src="`${uploadUrl}${item.invoiceImgId}`"
            alt=""
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="渠道维护"
      :visible.sync="isChannel"
      style="width: 100%"
      @close="cancelChanneBtn('dialogChannelForm')"
    >
      <el-form
        :model="dialogChannelForm"
        :rules="dialogChanneRules"
        ref="dialogChannelForm"
        label-width="80px"
        class="demo-dialogChannelForm"
        label-position="left"
      >
        <el-form-item label="渠道名称" prop="invoiceChannel">
          <el-input
            v-model="dialogChannelForm.invoiceChannel"
            placeholder="请输入渠道名称"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片" prop="invoiceChannel">
          <!-- 上传 -->
          <el-upload
            class="avatar-uploader"
            :action="`${upload}/file/uploadNew`"
            :show-file-list="false"
            :on-success="uploadChannelSuccess"
            list-type="picture-card"
          >
            <img v-if="imgChannelUrl" :src="imgChannelUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <div class="footerBtn">
          <el-button
            class="dialogWhite"
            @click="cancelChanneBtn('dialogChannelForm')"
            >取 消</el-button
          >
          <el-button
            class="dialogBtnBackgory"
            @click="submitChanneForm('dialogChannelForm')"
            >确 定</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "invoiceManage",
  data() {
    return {
      form: {
        invoiceChannelId: ""
      },
      uploadUrl: "",
      upload: "",
      ids: [],
      title: "新增",
      selectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },

      total: 0,
      tableData: [],
      dialogVisible: false,
      showStepGuidance: false,
      dialogForm: {
        pageAreaId: "",
        jumpLink: "",
        rotationRate: "",
        remark: "",
        imgUrl: ""
      },
      activeIndex: "",
      explainForm: {
        description: "",
        imgUrl: ""
      },
      descriptionList: [], //发票说明列表
      stepExplain: [], //步骤说明
      invoiceChannel: "",
      imgUrl: "",
      dialogRules: {
        invoiceChannelId: [
          { required: true, message: "请选择名称", trigger: "change" }
        ]
      },
      isChannel: false,
      dialogChannelForm: {
        invoiceChannel: "",
        imgId: ""
      },
      imgChannelUrl: "",
      dialogChanneRules: {
        invoiceChannel: [
          { required: true, message: "请输入渠道名称", trigger: "blur" }
        ],
        imgId: [{ required: true, message: "请选择图标" }]
      }
    };
  },
  mounted() {
    this.upload = apis.upload;
    this.uploadUrl = apis.uploadUrl;
    this.getSeleteDataList();
    this.getSearchList({ ...this.pageData });
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {
      apis.invoicesChannelList().then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.descriptionList = [];
      const json = {
        invoiceImgId: "",
        description: "",
        imgUrl: ""
      };
      this.descriptionList?.push(json);

      this.dialogVisible = true;
      this.title = "新增";
      delete this.dialogForm.id;
      this.dialogForm = {};
      this.$refs[formName]?.resetFields();
    },

    beforeUpload(index) {
      this.activeIndex = index;
    },
    uploadSuccess(res) {
      if (res.code === 200) {
        this.descriptionList[this.activeIndex].imgUrl =
          apis.uploadUrl + res.data.id;
        this.descriptionList[this.activeIndex].invoiceImgId = res.data.id;
      }
    },

    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      apis.invoicesDataList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    // 批量 删除
    deleteData() {
      if (this.ids.length) {
        apis.invoicesDeleteMap(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList({ ...this.pageData });
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },
    addFaultCause() {
      const json = {
        invoiceImgId: "",
        description: "",
        imgUrl: ""
      };
      this.descriptionList?.push(json);
    },
    // 删除发票说明
    deleteFaultCause(index) {
      if (this.descriptionList.length > 1) {
        this.descriptionList.splice(index, 1);
      }
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        const imageArray = this.descriptionList?.filter(item => {
          if (!item.invoiceImgId || !item.description) {
            return item;
          }
        });
        if (imageArray.length > 0) {
          return this.$message({
            message: "请选择图片或输入发票说明",
            type: "warning"
          });
        }
        if (valid) {
          const json = {
            ...this.dialogForm,
            descriptionList: this.descriptionList?.map(item => {
              delete item.imgUrl;
              return item;
            })
          };
          const Func = this.dialogForm.id
            ? apis.invoicesEdit(json)
            : apis.invoicesAdd(json);
          Func.then(res => {
            if (res.code === 200) {
              this.getSearchList({ ...this.pageData });
              this.dialogVisible = false;
              const msg = this.dialogForm.id ? "修改" : "新增";
              this.$message({
                message: `${msg}成功`,
                type: "success"
              });
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      this.getSeleteDataList();
      this.descriptionList = [];

      this.dialogForm = JSON.parse(
        JSON.stringify({
          id: row.id,
          invoiceChannelId: row.invoiceChannelId
        })
      );
      const json = {
        invoiceImgId: row.invoiceImgId,
        description: row.description,
        imgUrl: apis.uploadUrl + row.invoiceImgId
      };
      this.descriptionList.push(json);

      this.dialogVisible = true;
      this.title = "编辑";
    },
    // 渠道维护
    addChannel() {
      this.dialogChannelForm = {};
      this.imgChannelUrl = "";
      this.isChannel = true;
    },
    uploadChannelSuccess(res) {
      if (res.code === 200) {
        this.dialogChannelForm.imgId = res.data.id;
        this.imgChannelUrl = apis.uploadUrl + res.data.id;
        this.$refs["dialogChannelForm"].clearValidate();
      }
    },
    // 取消
    cancelChanneBtn(formName) {
      this.$refs[formName].resetFields();
      this.isChannel = false;
    },
    //确定
    submitChanneForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const json = {
            ...this.dialogChannelForm
          };
          apis.addChannel(json).then(res => {
            if (res.code === 200) {
              this.getSearchList({ ...this.pageData });
              this.getSeleteDataList();
              this.isChannel = false;
            }
          });
        }
      });
    },
    step(scope) {
      console.log(scope.row);
      this.invoiceChannel = scope.row.invoiceChannel;
      this.stepExplain = [];
      const json = {
        description: scope.row.description,
        invoiceImgId: scope.row.invoiceImgId
      };
      this.stepExplain.push(json);
      this.showStepGuidance = true;
    },
    // 删除一条
    deleteOnly(row) {
      apis.invoicesDeleteMap([row.id]).then(res => {
        if (res.code === 200) {
          this.getSearchList({ ...this.pageData });
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    }
  }

  // watch: {
  //   // tableData是el-table绑定的数据
  //   tableData: {
  //     // 解决表格显示错位问题
  //     handler() {
  //       this.$nextTick(() => {
  //         // tableRef是el-table绑定的ref属性值
  //         this.$refs.table.doLayout(); // 对 Table 进行重新布局
  //       });
  //     },
  //     deep: true
  //   }
  // }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}

::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }
  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
  ::v-deep .el-upload {
    width: 218px;
    height: 124px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
  ::v-deep .el-upload--picture-card {
    line-height: 124px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 218px;
    height: 124px;
    line-height: 124px;
    text-align: center;
  }
  .avatar {
    width: 218px;
    height: 124px;
    display: block;
  }
}
.content {
  display: flex;
  justify-content: space-around;
  border: 1px solid #c9c9c9;
  width: 992px;
  padding: 20px;
}
.guidance {
  .guidanceTitle {
    margin-bottom: 20px;
  }
  .guidanceContent {
    // width: 608px;
    // height: 324px;
    margin-bottom: 20px;
    .guidanceImg {
      // width: 608px;
      // height: 324px;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 992px;
    }
    .el-textarea__inner {
      width: 575px;
      min-height: 207px !important;
    }
  }
}
::v-deep .demo-dialogChannelForm {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 100%;
    // width: 178px;
    // height: 178px;
    // line-height: 178px;
    text-align: center;
  }
  .avatar {
    // width: 178px;
    // height: 178px;
    width: 100%;
    height: 100%;
    display: block;
  }
  .footerBtn {
    text-align: right;
    .dialogWhite {
      width: 145px;
      height: 54px;
    }
    .dialogBtnBackgory {
      width: 145px;
      height: 54px;
      background-color: #008754;
      color: white;
    }
  }
}
</style>
